import _kebabCase from "lodash/kebabCase";
export var themePrefixes = ['filter', 'animation', 'background', 'boxShadow', 'color', 'font', 'fontFamily', 'transition', 'transform', 'transitionTimingFunction', 'transitionDuration'];
export var themeProps = themePrefixes.map(_kebabCase);